import '../../styles/index.scss';
import { docReady } from '../helpers/docReady';
import { videoObserver } from '../helpers/videoObserver';
import { header } from '../sections/header';
import { announcementBar } from '../sections/announcementBar';
import { cartDrawer } from '../sections/cartDrawer';
import { collectionTabs } from '../sections/collectionTabs';
import { interactiveLogos } from '../sections/interactiveLogos';
import { richText } from '../sections/richText';
import { searchDrawer } from '../sections/searchDrawer';
import { videoCarousel } from '../sections/videoCarousel';
import { video } from '../sections/video';
import { collectionPasswordProtection } from '../snippets/collectionPasswordProtection';
import { lineItemBulkView } from '../snippets/lineItemBulkView';
docReady(() => {
    videoObserver();
    header();
    announcementBar();
    cartDrawer();
    collectionTabs();
    interactiveLogos();
    richText();
    searchDrawer();
    videoCarousel();
    video();
    collectionPasswordProtection();
    lineItemBulkView();
});
